import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";

function About() {
  return (
    <div className="color-scheme color-scheme--scheme-1">
      <Header />

      <div className="about-page">
        {/* Hero Image */}
        <div className="about-hero">
          <img
            src="/main/about1.webp"
            alt="Historic Apothecary Jars"
            className="hero-image"
          />
        </div>

        {/* Main Content */}
        <div className="about-content">
          <h1>Merz Apothecary and Sadiemall.site</h1>

          <h2 className="subtitle">
            The Original International Apothecary<sup>®</sup>
          </h2>

          {/* YouTube Video */}
          <div className="video-container">
            <iframe
              width="100%"
              height="400"
              src="https://www.youtube.com/embed/dQw4w9WgXcQ"
              title="Take A Look Inside Our Historic Apothecary"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>

          <div className="content-text">
            <p>
              Merz Apothecary has been a Chicago institution since 1875 that
              maintains a unique balance between modern (allopathic) medicine
              and traditional remedies. Now owned by the Qaiyum family, Merz
              Apothecary and the Shops at Merz operate with the belief that true
              health involves feeling good mentally, physically, and
              emotionally.
            </p>

            <p>
              Despite the growth and attention, the store has not lost its focus
              on the original apothecary concept. The staff hails from around
              the world and collectively speaks more than ten languages.
              Customers seek out the well-trained staff for the 150 years of
              health and product knowledge it has inherited. The location and
              people have changed over the years, but Merz Apothecary's goal has
              remained the same: providing superior and personal service for
              each customer's total well-being.
            </p>

            <p>
              Abdul Qaiyum and his son, Anthony, founded Sadiemall.site in 1998.
              The challenge here was to meld the Old World approach and
              knowledge of Merz Apothecary with the New World technology of
              e-commerce, without losing the vision and character that make Merz
              Apothecary special.
            </p>

            <p>
              Since launching Sadiemall, the Qaiyum family has been able to
              expand Merz Apothecary & Sadiemall to include private label brands
              Q Brothers, a men's grooming brand launched in 2014 and KOBO
              Candles, acquired in 2022.
            </p>

            <p>
              When you shop at Sadiemall you can be confident that you're
              dealing with a staff that has intimate knowledge of the products
              we offer. We're always listening to our customers and that
              knowledge directly shapes the information and products we provide
              to you.
            </p>
          </div>

          {/* Mission Section */}
          <div className="mission-section">
            <h2>Our Mission</h2>
            <p className="mission-text">
              We create the Merz Apothecary experience. We provide the world's
              best natural and unique products for health and personal care and
              share sought-after knowledge and guidance with honesty and
              passion. Through gracious service to our customers and each other,
              we strive to improve the lives of those we serve.
            </p>
          </div>

          <p className="visit-text">
            If you're ever in Chicago, please stop by our stores and say hello!
          </p>

          {/* Store Information */}
          <div className="store-info">
            <h2>Merz Apothecary & The Shops at Merz</h2>
            <div className="store-details">
              <p>1 Lancaster Road</p>
              <p>Cockerham, Lancaster, Lancashire, LA2 0EB</p>
              <p>(773) 989-0900</p>
              <p>Open Monday through Saturday, 10AM to 6PM</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default About;
